import { UserSelect } from '@organization/components'
import { useQueryUpdate } from '@shared/hooks'
import { Select, Space } from 'antd'
import { useTranslation } from 'react-i18next'

const lockoutTypes = [
  'otp_max_failed_verify_attempts',
  'otp_send_rate_limit',
  'max_daily_lockouts'
]

export const LockoutsFilters = () => {
  const { t } = useTranslation()
  const { params, updateQuery } = useQueryUpdate()

  return (
    <Space wrap>
      <UserSelect
        value={params.user}
        onChange={(user: string) => updateQuery({ user })}
      />

      <Select
        placeholder={t('table.type')}
        value={params.lockoutType}
        onChange={(lockoutType) => updateQuery({ lockoutType })}
        options={lockoutTypes.map((value) => ({
          label: t(`lockout_type.${value}`),
          value
        }))}
        className="select-min-width"
        allowClear
      />
    </Space>
  )
}
